/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";
import { invalidateAvailability } from "./invalidateAvailability";

export const useDeleteBooking = (id, isBatchCancel = false) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.deleteBooking(id),
    mutationFn: (data) =>
      fetcher({
        method: "DELETE",
        url: isBatchCancel ? `/public/booking/batch/id/${id}` : `/public/booking/item/id/${id}`,
        data,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.booking.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.client.bookingsAll });
      invalidateAvailability(queryClient);
    },
  });
};
